module.exports = __webpack_public_path__ + "static/media/screenshot-github-explorer.ad3cd20a.jpg";